import React from 'react';



export default class NoResultsBox extends React.PureComponent {

    render() {
        return (
            <div className={'box mt-6'}>
                <h5 className={'is-size-5 has-text-centered has-text-grey-light'}>{this.props.message || "No Results"}</h5>
            </div>
        )
    }
}
